var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeWidth: 0.501,
    strokeLinejoin: "bevel",
    fillRule: "evenodd",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    width: "0.5em",
    height: "0.5em",
    viewBox: "0 0 36 36.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document",
    fill: "none",
    stroke: "black",
    fontFamily: "Times New Roman",
    fontSize: 16,
    transform: "scale(1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Spread",
    transform: "translate(0 -36.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,5.476 L 0,28.408 C 0,31.43 2.475,33.891 5.506,33.891 L 7.686,33.891 L 7.686,36.753 L 11.016,36.753 L 11.016,33.891 L 24.983,33.891 L 24.983,36.753 L 28.31,36.753 L 28.31,33.891 L 30.494,33.891 C 33.524,33.891 35.999,31.43 35.999,28.408 L 35.999,5.476 C 35.999,2.447 33.522,-0.004 30.494,-0.004 L 5.506,-0.004 C 2.477,-0.004 0,2.447 0,5.476 Z M 32.677,5.476 L 32.677,22.928 L 3.33,22.928 L 3.33,5.476 C 3.33,4.281 4.306,3.311 5.506,3.311 L 30.494,3.311 C 31.698,3.311 32.677,4.283 32.677,5.476 Z M 6.384,5.905 L 6.384,11.132 L 11.629,11.132 L 11.634,5.905 L 6.384,5.905 Z M 15.372,5.905 L 15.372,11.132 L 20.624,11.132 L 20.624,5.905 L 15.372,5.905 Z M 24.983,5.905 L 24.983,11.132 L 30.231,11.132 L 30.231,5.905 L 24.983,5.905 Z M 15.372,14.672 L 15.372,19.902 L 20.624,19.902 L 20.624,14.672 L 15.372,14.672 Z M 24.983,14.672 L 24.983,19.902 L 30.231,19.902 L 30.231,14.672 L 24.983,14.672 Z M 32.677,26.241 L 32.677,28.408 C 32.677,29.594 31.698,30.571 30.494,30.571 L 28.316,30.571 L 28.316,28.654 L 24.99,28.654 L 24.99,30.571 L 11.016,30.571 L 11.016,28.654 L 7.686,28.654 L 7.686,30.571 L 5.506,30.571 C 4.3,30.571 3.33,29.597 3.33,28.408 L 3.33,26.241 L 32.677,26.241 Z",
    stroke: "none",
    fill: "#666666",
    fillRule: "evenodd",
    strokeLinejoin: "miter",
    strokeWidth: 1.405,
    markerStart: "none",
    markerEnd: "none",
    strokeMiterlimit: 79.8403193612775
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.365a77d407ef5d9135c6bd5584414385.svg";
export { ForwardRef as ReactComponent };